const rpcUrl = 'https://sentry-lb.evm-rpc.injective.network',
    blockExplorers = 'https://blockscout.injective.network'
export default {
    id: 1776,
    name: 'Injective',
    network: 'injective',
    nativeCurrency: {name: 'Injective', symbol: 'INJ', decimals: 18},
    rpcUrls: {
        default: {
            http: [rpcUrl],
        },
        public: {
            http: [rpcUrl],
        },
    },
    blockExplorers: {
        etherscan: {name: 'Injective explorer', url: blockExplorers},
        default: {name: 'Injective explorer', url: blockExplorers},
    },
    contracts: {},
}